import { css, SerializedStyles } from "@emotion/react";
import styled from "@emotion/styled";
import { Stack, ToggleButton } from "@mui/material";
import { shouldForwardProp } from "../utils";

type PpIndex = {
  $index: number;
};

export const StyledToggleButton = styled(ToggleButton, {
  shouldForwardProp,
})<PpIndex>`
  ${({ $index, theme }): SerializedStyles => css`
    position: relative;
    &.Mui-selected ~ ::before {
      transform: translateX(calc(100% * ${$index}));
    }
    .MuiTypography-toggle-btn--title {
      z-index: 2;
    }
    &:last-of-type::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      transition: ${theme.transitions.create("transform", {
        duration: theme.transitions.duration.shorter,
      })};
      border-radius: ${theme.shape.siteBorderRadius.toggleButton};
      background: ${theme.palette.site.toggleButton};
    }
  `}
`;

export const StyledContainer = styled(Stack)`
  z-index: 2;
`;
